"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const flatPage_1 = __importDefault(require("./flatPage"));
const flatPages = ({ pages, }) => Object.entries(pages)
    .reduce((accumulator, [pageId, page]) => {
    if (!page) {
        return accumulator;
    }
    return (0, flatPage_1.default)({
        pageId,
        page,
        initialObject: accumulator,
    });
}, {});
exports.default = flatPages;
